import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    isReloadedTimeLogs: false,
};
var reloadSlice = createSlice({
    name: 'site',
    initialState: initialState,
    reducers: {
        reloadTimeLogs: function (state) {
            state.isReloadedTimeLogs = !state.isReloadedTimeLogs;
        }
    },
});
export var reloadTimeLogs = reloadSlice.actions.reloadTimeLogs;
export default reloadSlice.reducer;
